import React, { useState, useEffect, useCallback } from 'react'

import PropTypes from 'prop-types'

import uniqueId from 'lodash/uniqueId'

import { useT } from '@galo-monitor/i18n'
import Checkbox from '@galo-monitor/web-components/Checkbox'

import { FuncionalityName, Content } from './styles'

const Functionality = (props) => {
  const { functionality, defaultPermissions, onChangePermissions, disabled } = props

  const [funcPermissions, setFuncPermissions] = useState({
    read: defaultPermissions?.reader ?? false,
    write: defaultPermissions?.created ?? false,
    edit: defaultPermissions?.edited ?? false,
    delete: defaultPermissions?.deleted ?? false
  })

  const t = useT()

  const handleCheckbox = useCallback(
    (level) => {
      setFuncPermissions(prevState => ({
        ...prevState,
        [level]: !funcPermissions[level]
      }))
    },
    [funcPermissions]
  )

  useEffect(() => {
    setFuncPermissions({
      read: defaultPermissions?.reader ?? false,
      write: defaultPermissions?.created ?? false,
      edit: defaultPermissions?.edited ?? false,
      delete: defaultPermissions?.deleted ?? false
    })
  }, [defaultPermissions])

  useEffect(() => {
    onChangePermissions(prevState => ({
      ...prevState,
      [functionality.id]: {
        ...funcPermissions
      }
    }))
  }, [funcPermissions, functionality.id, onChangePermissions])

  return (
    <Content>
      <FuncionalityName>
        {functionality.name}
      </FuncionalityName>

      <Checkbox
        detached
        id={ uniqueId('view') }
        name="view"
        label={ t('view') }
        checked={ funcPermissions?.read }
        onChange={ () => handleCheckbox('read') }
        style={ { marginBottom: 0 } }
        disabled={ disabled }
      />

      <Checkbox
        detached
        id={ uniqueId('register') }
        name="register"
        label={ t('register') }
        checked={ funcPermissions?.write }
        onChange={ () => handleCheckbox('write') }
        style={ { marginBottom: 0 } }
        disabled={ disabled }
      />

      <Checkbox
        detached
        id={ uniqueId('edit') }
        name="edit"
        label={ t('edit') }
        checked={ funcPermissions?.edit }
        onChange={ () => handleCheckbox('edit') }
        style={ { marginBottom: 0 } }
        disabled={ disabled }
      />

      <Checkbox
        detached
        id={ uniqueId('remove') }
        name="remove"
        label={ t('remove') }
        checked={ funcPermissions?.delete }
        onChange={ () => handleCheckbox('delete') }
        style={ { marginBottom: 0 } }
        disabled={ disabled }
      />
    </Content>
  )
}

Functionality.propTypes = {
  functionality: PropTypes.object.isRequired,
  defaultPermissions: PropTypes.object,
  onChangePermissions: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

Functionality.defaultProps = {
  disabled: false,
  defaultPermissions: {
    read: false,
    write: false,
    edit: false,
    delete: false
  }
}

export default Functionality
